<mat-button-toggle (click)="toggleExpanded()">
  <fa-icon
    [icon]="faAngleDoubleLeft"
    [flip]="(expanded$ | async) ? 'horizontal' : undefined"
    [fixedWidth]="true"
  ></fa-icon>
</mat-button-toggle>
